import { render, staticRenderFns } from "./shopMsg.vue?vue&type=template&id=756abcd0&scoped=true"
import script from "./shopMsg.vue?vue&type=script&lang=js"
export * from "./shopMsg.vue?vue&type=script&lang=js"
import style0 from "./shopMsg.vue?vue&type=style&index=0&id=756abcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756abcd0",
  null
  
)

export default component.exports